var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56396 12.8877C7.9502 12.8877 9.22852 12.4395 10.2744 11.6924L14.209 15.627C14.3916 15.8096 14.6323 15.9009 14.8896 15.9009C15.4292 15.9009 15.811 15.4858 15.811 14.9546C15.811 14.7056 15.728 14.4648 15.5454 14.2905L11.6357 10.3726C12.4575 9.29346 12.9473 7.95703 12.9473 6.50439C12.9473 2.99316 10.0752 0.121094 6.56396 0.121094C3.06104 0.121094 0.180664 2.98486 0.180664 6.50439C0.180664 10.0156 3.05273 12.8877 6.56396 12.8877ZM6.56396 11.5098C3.82471 11.5098 1.55859 9.24365 1.55859 6.50439C1.55859 3.76514 3.82471 1.49902 6.56396 1.49902C9.30322 1.49902 11.5693 3.76514 11.5693 6.50439C11.5693 9.24365 9.30322 11.5098 6.56396 11.5098Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.ed1d7769f02b483c9b89a37908e5af00.svg";
export { ForwardRef as ReactComponent };